module.exports = __webpack_public_path__ + "static/media/javascript-logo.b4cc9b6d.png";